import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../../Assets/Css/NotificationBellModal.css";
import notificationIcon from "../../Assets/Images/Images/notificationIcon.svg"; // Ensure the path is correct
import { GetAPI } from "../../ApiServices/ApiServices"; // Import the GetAPI function

const NotificationBellModal = () => {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    // Fetch the doctor ID from local storage
    const doctorId = localStorage.getItem("userId");

    if (doctorId) {
      // Fetch notifications from the API
      GetAPI(`/doctor/notification/${doctorId}`, (response) => {
        if (response.status === 1 && response.code === 200) {
          // Transform the API response into the format expected by the component
          const transformedNotifications = transformNotifications(response.data);
          setNotifications(transformedNotifications);
        }
      });
    }
  }, []);

  // Function to transform the API response
  const transformNotifications = (data) => {
    const transformed = [];

    for (const date in data) {
      for (const appointmentId in data[date]) {
        const appointment = data[date][appointmentId];
        transformed.push({
          id: appointmentId,
          message: `${appointment.appointment_count} Patients are waiting for your appointment on ${appointment.appointment_date}, at ${appointment.slot_time}`,
          icon: notificationIcon, // Use the imported notificationIcon
          appointmentDate: appointment.appointment_date, // Add appointment date
          slotTime: appointment.slot_time, // Add slot time
        });
      }
    }

    return transformed;
  };

  // Handle click on a notification item
  const handleNotificationClick = (notification) => {
    // Navigate to the Appointments component with activeTab set to "requests"
    navigate("/appointments", {
      state: { activeTab: "requests" }, // Pass the activeTab state
    });
  };

  return (
    <div className="notification-modal">
      <div className="notification-header">
        <h4>Notifications</h4>
        <button className="clear-btn">Clear all</button>
      </div>
      <div className="notification-list">
        {notifications.map((notification) => (
          <div
            key={notification.id}
            className="notification-item"
            onClick={() => handleNotificationClick(notification)} // Add click handler
          >
            <img src={notification.icon} alt="icon" className="notification-icon" />
            <p className="notification-text">{notification.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationBellModal;